import { CalloutBox } from 'components/Docs/CalloutBox';
import RevAnalyticsBetaWarning from "../../../../contents/docs/revenue-analytics/_snippets/rev-analytics-beta-warning.mdx";
import * as React from 'react';
export default {
  CalloutBox,
  RevAnalyticsBetaWarning,
  React
};